export default "__VITE_ASSET__2lPtRQbt__"